/**
 * FollowUpPrompts — forslagschipene over inntastingsfeltet mens en samtale
 * pågår (#158, Stell_Assistent).
 *
 * Samme forslag som i den tomme tråden (SuggestedPrompts), i en vannrett rad
 * som kan rulles. Et trykk sender forslaget direkte, akkurat som der. Mens et
 * svar strømmer, er chipene deaktivert i stedet for skjult, så raden ikke
 * hopper.
 *
 * Knappene er `Button secondary` (44 px), ikke `Chip`: de er snarveier som
 * sender, ikke filtre som slås av og på, så `aria-pressed` ville vært feil.
 *
 * data-testid: assistant-followup-prompts, assistant-followup-chip-{index}
 */
import { useTranslation } from 'react-i18next';
import { Button } from '../../components/primitives/Button';
import { suggestedPromptKeys, type PromptRole } from './prompts';

interface FollowUpPromptsProps {
  role: PromptRole;
  onSelect: (text: string) => void;
  disabled: boolean;
}

export function FollowUpPrompts({ role, onSelect, disabled }: FollowUpPromptsProps) {
  const { t } = useTranslation();
  return (
    <div
      role="group"
      aria-label={t('assistant.suggested.title')}
      data-testid="assistant-followup-prompts"
      className="no-scrollbar -mx-5 flex gap-2 overflow-x-auto px-5 md:-mx-8 md:px-8"
    >
      {suggestedPromptKeys(role).map((key, idx) => {
        const text = t(key);
        return (
          <Button
            key={key}
            variant="secondary"
            size={44}
            disabled={disabled}
            data-testid={`assistant-followup-chip-${idx}`}
            onClick={() => onSelect(text)}
            className="shrink-0 whitespace-nowrap"
          >
            {text}
          </Button>
        );
      })}
    </div>
  );
}
